import React, { useRef, useState, useEffect } from "react";
import { customAPI } from "services/utils/CustomAPI";
import { formKeyText } from "services/constants/Styles";
import { CustomTextBox } from "components/CustomComponents";
import { useForm } from "react-hook-form";
import { checkEditorPermission } from "services/utils/HelperFunction";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { useFetch } from "services/hooks/useFetch";
import { useSelector } from "react-redux";
import { Loader } from "components/Loader";
import { CustomButton } from "components/CustomComponents";
import { GlobalDialogBox } from "components/GlobalDialogBox";
import { InfoMessage } from "components/CustomComponents/CustomButton";
import * as Mui from "@mui/material";
import { Edit } from "@mui/icons-material";
import { showToast } from "services/utils/Status";
import { tooltipStyleProps } from "services/constants/Styles";
import { Info } from "@mui/icons-material";
import {
  themes,
  tableHeaderSx,
  tableRowSx,
  scrollTop,
} from "services/constants";
export const BioDevice = () => {
  const { domain, topbarCompanyId, userScreenAccess, globalSearchValue } =
    useSelector((state) => state.tokenReducer);
  const {
    result: companyAllDetails,
    setLoad,
    loading,
  } = useFetch(`${domain}device-details/?company_id=${topbarCompanyId}`);
  let check_access = checkEditorPermission(
    userScreenAccess?.module_details,
    "Master",
    "Biometric device"
  );
  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm();
  const [openDialog, setOpenDialog] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const [editLocation, setEditLocation] = useState({});
  const tableContainerRef = useRef(null);
  const [biometricDetails, setBioMetricDetails] = useState([]);
  const [tableHeight, setTableHeight] = useState(window.innerHeight * 0.75);
  const TypeList = [
    {
      name: "Attendance",
    },
    {
      name: "Patrol",
    },
  ];

  useEffect(() => {
    if (topbarCompanyId) {
      setLoad(true);
    }
  }, [setLoad, topbarCompanyId]);

  useEffect(() => {
    const updateHeight = () => {
      setTableHeight(window.innerHeight * 0.75);
    };

    window.addEventListener("resize", updateHeight);

    return () => window.removeEventListener("resize", updateHeight);
  }, []);

  useEffect(() => {
    scrollTop(tableContainerRef);
  }, [page]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const onSubmit = async (data) => {
    const response = await customAPI(`${domain}edit/device/location/`, "PUT", {
      location: data?.location_name,
      device_type: data?.device_type,
      device_id: editLocation?.device_id,
    });
    if (response.ok) {
      setLoad(true);
      showToast("success", response?.responseDetails?.message);
      setOpenDialog(false);
      reset();
    }
  };

  const handleLocationName = (event) => {
    setValue("location_name", event.target.value);
  };

  const handleDeviceType = (event, data) => {
    setValue("device_type", data?.name);
  };

  useEffect(() => {
    const searchFields = [
      "serial_number",
      "device_name",
      "location",
      "device_type",
      "device_id",
    ];
    const filteredResults = companyAllDetails.filter((item) =>
      searchFields.some((key) =>
        item[key]
          ?.toString()
          .toLowerCase()
          .includes(globalSearchValue.toString().toLowerCase())
      )
    );
    setBioMetricDetails(filteredResults);
    setPage(globalSearchValue ? 0 : page);
  }, [globalSearchValue, companyAllDetails, page]);

  return loading ? (
    <Loader info="Loading..." />
  ) : (
    <React.Fragment>
      <Mui.Grid container sx={{ paddingTop: 2, padding: 2 }}>
        <Mui.TableContainer
          sx={{
            mt: 2,
            width: "100%",
            ml: 2,
            mr: 2,
            maxHeight: tableHeight,
          }}
          ref={tableContainerRef}
          id="check"
        >
          <Mui.Table className="border">
            <Mui.TableHead sx={tableHeaderSx}>
              <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  Device ID
                </Mui.TableCell>
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  Device Name
                </Mui.TableCell>
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  Serial Number
                </Mui.TableCell>
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  Device Type
                </Mui.TableCell>
                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  Location
                </Mui.TableCell>

                <Mui.TableCell
                  sx={{ color: themes.headLine, fontWeight: "bold" }}
                >
                  Action
                </Mui.TableCell>
              </Mui.TableRow>
            </Mui.TableHead>
            <Mui.TableBody>
              {biometricDetails.length === 0 && loading === false ? (
                <InfoMessage dataLength={companyAllDetails} />
              ) : (
                biometricDetails
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item, index) => (
                    <Mui.TableRow maxWidth="xl" align="left" sx={tableRowSx}>
                      <Mui.TableCell
                        sx={{ color: themes.headLine, fontWeight: "bold" }}
                      >
                        <Mui.Typography>
                          {item?.device_id ? item?.device_id : "N/A"}
                        </Mui.Typography>
                      </Mui.TableCell>
                      <Mui.TableCell
                        sx={{ color: themes.headLine, fontWeight: "bold" }}
                      >
                        <Mui.Typography>
                          {item?.device_name ? item?.device_name : "N/A"}
                        </Mui.Typography>
                      </Mui.TableCell>
                      <Mui.TableCell
                        sx={{ color: themes.headLine, fontWeight: "bold" }}
                      >
                        <Mui.Typography>
                          {item?.serial_number ? item?.serial_number : "N/A"}
                        </Mui.Typography>
                      </Mui.TableCell>
                      <Mui.TableCell
                        sx={{ color: themes.headLine, fontWeight: "bold" }}
                      >
                        <Mui.Typography>
                          {item?.device_type ? item?.device_type : "N/A"}
                        </Mui.Typography>
                      </Mui.TableCell>
                      <Mui.TableCell
                        sx={{ color: themes.headLine, fontWeight: "bold" }}
                      >
                        <Mui.Typography>
                          {item?.location?.length > 50
                            ? item?.location.substr(0, 50) + "..."
                            : item?.location
                            ? item?.location?.length > 50
                              ? item?.location.substr(0, 50) + "..."
                              : item?.location
                            : "N/A"}
                        </Mui.Typography>
                      </Mui.TableCell>

                      <Mui.TableCell
                        sx={{ color: themes.headLine, fontWeight: "bold" }}
                      >
                        <Mui.IconButton
                          onClick={(event) => {
                            if (check_access) {
                              reset();
                              setValue("location_name", item.location);
                              setValue("device_type", item?.device_type);
                              setEditLocation(item);
                              // setAnchorEl(false);
                              setOpenDialog(true);
                              // setAnchorEl(event.currentTarget);
                            } else {
                              showToast(
                                "error",
                                `Access denied: You are not authorized to edit biometric device.`
                              );
                            }
                          }}
                          sx={{ marginLeft: 1 }}
                        >
                          <Edit />
                        </Mui.IconButton>
                      </Mui.TableCell>
                    </Mui.TableRow>
                  ))
              )}
            </Mui.TableBody>
          </Mui.Table>
        </Mui.TableContainer>
        <Mui.Grid
          container
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-end",
            alignItems: "flex-end",
          }}
        >
          {biometricDetails.length > 25 ? (
            <Mui.TablePagination
              className="custom-pagination"
              component="div"
              rowsPerPageOptions={[25, 50, 75, 100]}
              count={biometricDetails.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          ) : null}
        </Mui.Grid>
      </Mui.Grid>
      <GlobalDialogBox
        open={openDialog}
        handleCloseDialog={() => setOpenDialog(false)}
        title="Change Device Location Name"
        minWidth={700}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Mui.Grid container>
            <Mui.Grid xs={6}>
              <Mui.Typography sx={formKeyText}>
                Serial Number&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Display the unique identifier for the device. This field is read-only and used for reference."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={6}>
              <Mui.Typography sx={{ paddingTop: 2, fontSize: 15 }}>
                {editLocation?.serial_number}
              </Mui.Typography>
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container>
            <Mui.Grid xs={6}>
              <Mui.Typography sx={formKeyText}>
                Device Name&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Display the name of the device associated with the serial number. Also read-only, it helps identify the device being updated.
"
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={6}>
              <Mui.Typography sx={{ paddingTop: 2, fontSize: 15 }}>
                {editLocation?.device_name}
              </Mui.Typography>
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container>
            <Mui.Grid xs={6}>
              <Mui.Typography sx={formKeyText}>
                Device Type&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Choose your prefer device type"
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={6} sx={{ paddingTop: 1 }}>
              <CustomAutoComplete
                dataList={TypeList.map((obj) => ({
                  ...obj,
                  label: obj.name,
                }))}
                selectedValue={watch("device_type")}
                rules={{
                  ...register("device_type", {
                    required: "Device type is required",
                  }),
                }}
                updateDataFunction={handleDeviceType}
                placeHolder="Select the device type"
                errorMessage={
                  errors?.device_type?.message
                    ? errors?.device_type?.message
                    : ""
                }
                textBoxError={errors.device_type ? true : false}
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.Grid container>
            <Mui.Grid xs={6}>
              <Mui.Typography sx={formKeyText}>
                Location Name&nbsp;
                <Mui.Tooltip
                  arrow
                  slotProps={tooltipStyleProps}
                  title="Enter the new or updated location name. This is the label that will appear in all device-related logs and views."
                >
                  <Info />
                </Mui.Tooltip>
              </Mui.Typography>
            </Mui.Grid>
            <Mui.Grid xs={6} sx={{ paddingTop: 1 }}>
              <CustomTextBox
                selectedValue={watch("location_name")}
                rules={{
                  ...register("location_name", {
                    required: "Location name is required",
                  }),
                }}
                updateDataFunction={handleLocationName}
                placeHolder="Enter the location name"
                errorMessage={
                  errors?.location_name?.message
                    ? errors?.location_name?.message
                    : ""
                }
                textBoxError={errors.location_name ? true : false}
              />
            </Mui.Grid>
          </Mui.Grid>
          <Mui.DialogActions>
            <CustomButton
              actionFuntion={() => setOpenDialog(false)}
              actionName="Cancel"
              typeName="button"
            />
            &nbsp;&nbsp;
            <CustomButton actionName="Change" typeName="submit" />
          </Mui.DialogActions>
        </form>
      </GlobalDialogBox>
    </React.Fragment>
  );
};
